<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="2" class="text-center px-0">
        <img
          :src="imageDisplay"
          alt="..."
          class="img-thumbnail align-middle my-2 personal_image_10 object__fit--cover"
          @error="errorImg"
        />
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            v-if="permissionButton"
            @click="view_fileManger = !view_fileManger"
            variant="outline-success"
            class="d-flex align-items-center justify-content-between w-100"
          >
            <span>{{ $lang.uploadProfileImage }}</span>
            <mdicon name="camera-outline" size="16" />
          </b-button>
        </div>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="view_fileManger"
          size="xl"
          ok-only
          hide-header
        >
          <UploadFile
            :crop="true"
            :title="$lang.uploadProfileImage"
            :topAlert="$lang.uploadProfileImageAlertMessage"
            :file_types="file_types"
            :parentAttachmentTypeId="10"
            :parentPermissions="parentPermissions"
            :keyServies="keyServies"
            :keyValue="pathOr(null, ['code'], item)"
            :showForm="false"
            :allowCollapse="false"
            :isCollapseFiles="true"
            :parentUploadFile="true"
            :parentAspectRatio="false"
            :parentInitialAspectRatio="false"
            :showCheckbox="true"
            :maxCountUploadFiles="1"
            :maxUploadFile="10485760"
            :allowFileSize="10240"
            :outParams="{ attachment_type_id: [10] }"
          />
          <template v-slot:modal-footer>
            <b-button
              class="ml-2"
              variant="outline-danger"
              @click="uploadClose"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
          </template>
        </b-modal>
      </b-col>
      <b-col cols="12" md="10">
        <b-row class="bg-light rounded m-0 mb-3">
          <b-col cols="12" md="" class="pad-5">
            <b-form-group
              :label="$lang.name"
              label-for="name"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.name"
                :rules="$v.name.$params"
              />
              <b-form-input
                id="name"
                type="text"
                :autocomplete="$lang.name"
                v-model="$v.name.$model"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                disabled
              ></b-form-input>

              <b-form-invalid-feedback
                v-if="!$v.name.required"
                id="name-feedback"
              >
                {{ $lang.error_required | replace($lang.name) }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-if="$v.name.required && !$v.name.maxLengh"
                id="name-feedback"
              >
                {{
                  $lang.error_max | replace($lang.name, "بین 2 تا 35")
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="" class="pad-5">
            <b-form-group
              :label="$lang.family"
              label-for="family"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.family"
                :rules="$v.family.$params"
              />
              <b-form-input
                id="family"
                v-model="$v.family.$model"
                :state="$v.family.$dirty ? !$v.family.$error : null"
                disabled
                type="text"
                :autocomplete="$lang.family"
              >
              </b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.family.required"
                id="family-feedback"
              >
                {{
                  $lang.error_required | replace($lang.family)
                }}</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="$v.family.required && !$v.family.maxLengh"
                id="family-feedback"
              >
                {{
                  $lang.error_max | replace($lang.family, "بین 3 تا 35")
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="" class="pad-5">
            <b-form-group
              :label="$lang.national_code"
              label-for="national_code"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.national_code"
                :rules="$v.national_code.$params"
              />
              <b-form-input
                id="national_code"
                v-model="$v.national_code.$model"
                disabled
                :state="
                  $v.national_code.$dirty ? !$v.national_code.$error : null
                "
                type="text"
                :autocomplete="$lang.national_code"
              ></b-form-input>
              <b-form-invalid-feedback id="father_name-feedback">
                {{ $lang.error_required | replace($lang.national_code) }}
              </b-form-invalid-feedback>
              <div class="invalid-feedback" v-if="!$v.national_code.numeric">
                {{ $lang.error_numeric | replace($lang.national_code) }}
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  ($v.national_code.numeric && !$v.national_code.minLength) ||
                  !$v.national_code.maxLength
                "
              >
                {{ $lang.error_max | replace($lang.national_code, 10) }}
              </div>
            </b-form-group>
          </b-col>
          <b-col
            v-if="isMyProfile || adminIdentityChange"
            cols="12"
            md=""
            class="pad-5 d-flex align-items-end justify-content-center pb-3"
            v-b-tooltip.hover
            :title="$lang.change_person_identity_request"
          >
            <b-button
              block
              variant="success"
              :disabled="personIdentityLoading"
              @click="personIdentityChange()"
            >
              <span v-if="personIdentityLoading">
                <b-spinner small />
                {{ $lang.search.check_loading }}
              </span>
              <span
                v-else
                class="ml-1"
                v-text="$lang.change_person_information"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="4" class="pad-5">
            <b-form-group
              :label="$lang.birth_certificate"
              label-for="birth_certificate"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.birth_certificate"
                :rules="$v.birth_certificate.$params"
                :showRequired="isRequiredPersonFields"
              />
              <b-form-input
                id="birth_certificate"
                type="text"
                :autocomplete="$lang.birth_certificate"
                v-model="$v.birth_certificate.$model"
                :state="
                  $v.birth_certificate.$dirty
                    ? !$v.birth_certificate.$error
                    : null
                "
              ></b-form-input>
              <b-form-invalid-feedback id="father_name-feedback">
                {{ $lang.error_required | replace($lang.birth_certificate) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="pad-5">
            <b-form-group
              :label="$lang.gender"
              label-for="gender_id"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.gender"
                :rules="$v.gender_selected.$params"
              />
              <selectFind
                :options="gender_options"
                v-model="$v.gender_selected.$model"
                label="text"
                class="multiselect-form"
                :isValid="
                  $v.gender_selected.$dirty ? !$v.gender_selected.$error : null
                "
              />

              <b-form-invalid-feedback
                :style="{
                  display: $v.gender_selected.$error ? 'block' : 'none',
                }"
                id="gender_id-feedback"
              >
                {{
                  $lang.error_required | replace($lang.gender)
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="pad-5">
            <b-form-group
              :label="$lang.birth_date"
              label-for="birth_date"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.birth_date"
                :rules="$v.birth_date.$params"
                :showRequired="isRequiredPersonFields"
              />
              <date-picker
                v-model="$v.birth_date.$model"
                :state="$v.birth_date.$dirty ? !$v.birth_date.$error : null"
                format="YYYY/MM/DD"
                display-format="jYYYY/jMM/jDD"
                min="1922/01/02"
                :max="new Date() | moment('YYYY/MM/DD')"
                inputReq="true"
                clearable
                :class="
                  $v.birth_date.$dirty
                    ? $v.birth_date.$error
                      ? 'invalid-date'
                      : 'valid-date'
                    : null
                "
              >
              </date-picker>
              <b-form-invalid-feedback
                :style="{ display: $v.birth_date.$error ? 'block' : 'none' }"
                id="gender_id-feedback"
              >
                {{
                  $lang.error_required | replace($lang.birth_date)
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="mb-3">
            <b-card no-body>
              <template #header>
                <div class="d-flex align-items-center justify-content-between">
                  <span>{{ $lang.other_information }}</span>
                  <b-button
                    variant="outline-success"
                    @click="collapseModel = !collapseModel"
                  >
                    <span v-if="collapseModel">
                      <mdicon name="chevron-up" size="20" />
                    </span>
                    <span v-else>
                      <mdicon name="chevron-down" size="20" />
                    </span>
                  </b-button>
                </div>
              </template>
              <b-collapse v-model="collapseModel" id="collapse">
                <b-row class="p-3">
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.previous_lastname"
                      label-for="previous_lastname"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.previous_lastname"
                        :rules="$v.previous_lastname.$params"
                      />
                      <b-form-input
                        id="previous_lastname"
                        type="text"
                        :autocomplete="$lang.previous_lastname"
                        v-model="$v.previous_lastname.$model"
                        :state="
                          $v.previous_lastname.$dirty
                            ? !$v.previous_lastname.$error
                            : null
                        "
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.alias"
                      label-for="alias"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.alias"
                        :rules="$v.alias.$params"
                      />
                      <b-form-input
                        id="alias"
                        type="text"
                        :autocomplete="$lang.alias"
                        v-model="$v.alias.$model"
                        :state="$v.alias.$dirty ? !$v.alias.$error : null"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.father_name"
                      label-for="father_name"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.father_name"
                        :rules="$v.father_name.$params"
                        :showRequired="isRequiredPersonFields"
                      />
                      <b-form-input
                        id="father_name"
                        type="text"
                        v-model="$v.father_name.$model"
                        :state="
                          $v.father_name.$dirty ? !$v.father_name.$error : null
                        "
                        :autocomplete="$lang.father_name"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="father_name-feedback">
                        {{ $lang.error_required | replace($lang.father_name) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      v-if="isPlaceIssueCombo"
                      :label="$lang.Place_issuance_identity_card"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.Place_issuance_identity_card"
                        :rules="$v.place_issue_combo.$params"
                        :showRequired="
                          isRequiredPersonFields && isPlaceIssueCombo
                        "
                      />
                      <selectAsync
                        :options="place_issue_combo_options"
                        v-model="$v.place_issue_combo.$model"
                        label="caption"
                        id="id"
                        :asyncFind="getPlaceIssueCombo"
                        :isValid="
                          $v.place_issue_combo.$dirty
                            ? !$v.place_issue_combo.$error
                            : null
                        "
                        :loading="place_issue_combo_Loading"
                      />

                      <b-form-invalid-feedback
                        :style="{
                          display: $v.place_issue_combo.$error
                            ? 'block'
                            : 'none',
                        }"
                        id="gender_id-feedback"
                      >
                        {{
                          $lang.error_required
                            | replace($lang.Place_issuance_identity_card)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      v-else
                      :label="$lang.Place_issuance_identity_card"
                      label-for="Place_issuance_identity_card"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.Place_issuance_identity_card"
                        :rules="$v.Place_issuance_identity_card.$params"
                        :showRequired="
                          isRequiredPersonFields && !isPlaceIssueCombo
                        "
                      />
                      <b-form-input
                        id="Place_issuance_identity_card"
                        type="text"
                        :autocomplete="$lang.Place_issuance_identity_card"
                        v-model="$v.Place_issuance_identity_card.$model"
                        :state="
                          $v.Place_issuance_identity_card.$dirty
                            ? !$v.Place_issuance_identity_card.$error
                            : null
                        "
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="father_name-feedback">
                        {{
                          $lang.error_required
                            | replace($lang.Place_issuance_identity_card)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.birth_location"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.birth_location"
                        :rules="$v.birthLocation.$params"
                      />
                      <selectAsync
                        :options="birthLocationOptions"
                        v-model="$v.birthLocation.$model"
                        label="caption"
                        id="id"
                        :asyncFind="getBirthLocationCombo"
                        :isValid="
                          $v.birthLocation.$dirty
                            ? !$v.birthLocation.$error
                            : null
                        "
                        :loading="birthLocationLoading"
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.birthLocation.$error ? 'block' : 'none',
                        }"
                        id="birthLocation-feedback"
                      >
                        {{
                          $lang.error_required | replace($lang.birth_location)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.religion"
                      label-for="religion_id"
                      :label-cols="$config.form.labelCol"
                      class="multiselect-form"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.religion"
                        :rules="$v.religion_selected.$params"
                        :showRequired="isRequiredPersonFields"
                      />
                      <selectFind
                        :options="religion_options"
                        v-model="$v.religion_selected.$model"
                        label="text"
                        :isValid="
                          $v.religion_selected.$dirty
                            ? !$v.religion_selected.$error
                            : null
                        "
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.religion_selected.$error
                            ? 'block'
                            : 'none',
                        }"
                        v-if="
                          $v.religion_selected.$dirty
                            ? !$v.religion_selected.$error
                            : null
                        "
                        id="religion_id-feedback"
                      >
                        {{
                          $lang.error_required | replace($lang.religion)
                        }}</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.allegiance"
                      label-for="allegiance"
                      :label-cols="$config.form.labelCol"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.allegiance"
                        :rules="$v.allegiance.$params"
                      />
                      <b-form-input
                        id="allegiance"
                        type="text"
                        :autocomplete="$lang.allegiance"
                        v-model="$v.allegiance.$model"
                        :state="
                          $v.allegiance.$dirty ? !$v.allegiance.$error : null
                        "
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4" class="pad-5">
                    <b-form-group
                      :label="$lang.marriage"
                      label-for="marriage_id"
                      :label-cols="$config.form.labelCol"
                      class="multiselect-form"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.marriage"
                        :rules="$v.marriage_selected.$params"
                      />
                      <selectFind
                        :options="marriage_options"
                        v-model="$v.marriage_selected.$model"
                        label="text"
                        :isValid="
                          $v.marriage_selected.$dirty
                            ? !$v.marriage_selected.$error
                            : null
                        "
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.marriage_selected.$error
                            ? 'block'
                            : 'none',
                        }"
                        v-show="
                          $v.marriage_selected.$dirty
                            ? !$v.marriage_selected.$error
                            : null
                        "
                        id="marriage_id-feedback"
                      >
                        {{
                          $lang.error_required | replace($lang.marriage)
                        }}</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                  <b-col
                    v-if="gender_selected && gender_selected.value == 1"
                    cols="12"
                    md="4"
                    class="pad-5"
                  >
                    <b-form-group
                      :label="$lang.military_service_status"
                      label-for="military_service_status_id"
                      :label-cols="$config.form.labelCol"
                      class="multiselect-form"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.military_service_status"
                        :rules="$v.military_service_status_selected.$params"
                        :showRequired="isRequiredPersonFields"
                      />
                      <selectFind
                        :options="military_service_status_options"
                        v-model="$v.military_service_status_selected.$model"
                        label="text"
                        :isValid="
                          $v.military_service_status_selected.$dirty
                            ? !$v.military_service_status_selected.$error
                            : null
                        "
                      />
                      <b-form-invalid-feedback
                        :style="{
                          display: $v.military_service_status_selected.$error
                            ? 'block'
                            : 'none',
                        }"
                        id="military_service_status_id-feedback"
                      >
                        {{
                          $lang.error_required
                            | replace($lang.military_service_status)
                        }}</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </b-col>
          <b-col cols="12">
            <div
              slot="footer"
              v-if="permissionButton"
              class="form-group form-btn mt-1"
            >
              <b-button
                v-if="isAdmin(parentPermissions)"
                type="submit"
                variant="success"
                @click="addItem"
              >
                <mdicon name="check" size="20" />
                {{ $lang.submitButton }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="personIdentityModal"
      size="md"
      hide-footer
      hide-header
    >
      <AddPersonIdentity
        :code="code"
        :oldName="name"
        :oldFamily="family"
        :oldNationalCode="national_code"
        :parentPermissions="parentPermissions"
        :adminIdentityChange="adminIdentityChange"
        @close="closePersonIdentityModal"
      />
    </b-modal>
  </div>
</template>
<script>
import AddPersonIdentity from "../personIdentity/components/AddPersonIdentity.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import UploadFile from "@/components/base/uploadFile";
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  renderEumOptions,
  renderEumOptionsSelected,
  generateApiUrl,
  isAdmin,
  checkCustomKey,
} from "@/shared/utils";

export default {
  name: "edit-person-form",
  components: {
    datePicker: VuePersianDatetimePicker,
    UploadFile,
    AddPersonIdentity,
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30),
    },
    family: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(35),
    },
    birth_certificate: {
      numeric,
      required: requiredIf((vm) => vm.isRequiredPersonFields),
    },
    national_code: {
      numeric,
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    birth_date: {
      required: requiredIf((vm) => vm.isRequiredPersonFields),
    },
    father_name: {
      required: requiredIf((vm) => vm.isRequiredPersonFields),
    },
    marriage_selected: {},
    alias: {},
    Place_issuance_identity_card: {
      required: requiredIf(
        (vm) => vm.isRequiredPersonFields && !vm.isPlaceIssueCombo
      ),
    },
    place_issue_combo: {
      required: requiredIf(
        (vm) => vm.isRequiredPersonFields && vm.isPlaceIssueCombo
      ),
    },
    birthLocation: {},
    previous_lastname: {},
    religion_selected: {
      required: requiredIf((vm) => vm.isRequiredPersonFields),
    },
    gender_selected: {
      required,
    },
    military_service_status_selected: {
      required: requiredIf(
        (vm) =>
          vm.isRequiredPersonFields &&
          vm.gender_selected &&
          vm.gender_selected.value == 1
      ),
    },
    allegiance: {},
  },
  props: {
    permissionButton: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    // from upload file keySerives
    keyServies: {
      type: String,
      default: "",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      default: null,
    },
    isMyProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      view_fileManger: false,
      Place_issuance_identity_card: null,
      family: null,
      birth_certificate: null,
      name: null,
      father_name: null,
      national_code: null,
      birth_date: null,
      gender_selected: null,
      marriage_selected: null,
      allegiance: null,
      internal_code: "",
      imageDisplay: "",
      religion_selected: {},
      military_service_status_selected: {},
      personIdentityLoading: false,
      personIdentityModal: false,
      file_types: ["image", "office", "media", "other"],
      adminIdentityChange: false,
      place_issue_combo: null,
      place_issue_combo_Loading: false,
      birthLocation: null,
      birthLocationOptions: [],
      birthLocationLoading: false,
      place_issue_combo_options: [],
      collapseModel: false,
    };
  },
  computed: {
    religion_options() {
      return renderEumOptions("religion");
    },
    gender_options() {
      return renderEumOptions("gender");
    },
    marriage_options() {
      return renderEumOptions("marriage");
    },
    military_service_status_options() {
      return renderEumOptions("military_type");
    },
    isRequiredPersonFields() {
      return this.$customConfig.isRequiredPersonFields;
    },
    isPlaceIssueCombo() {
      return checkCustomKey("isPlaceIssueCombo", false);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    renderEumOptions,
    isAdmin,
    checkCustomKey,
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noPerson;
      }
    },
    uploadClose() {
      this.view_fileManger = false;
      this.$emit("uploadClose");
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      (this.name = null)((this.family = null))((this.birth_date = ""))(
        (this.national_code = null)
      )((this.father_name = null))((this.gender_id = null))(
        (this.marriage_id = null)
      )((this.company_code = null));
    },
    addItem() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const payload = {
        internal_code: this.internal_code,
        identify: this.birth_certificate,
        nickname: this.alias,
        previous_family: this.previous_lastname,
        father_name: this.father_name,
        birth_date: this.birth_date,
        marriage_id: pathOr(null, ["value"], this.marriage_selected),
        gender_id: pathOr(null, ["value"], this.gender_selected),
        place_issue: this.Place_issuance_identity_card,
        religion_id: pathOr(null, ["value"], this.religion_selected),
        allegiance_caption: this.allegiance,
        military_id: pathOr(
          null,
          ["value"],
          this.military_service_status_selected
        ),
        place_issue_id: pathOr(null, ["id"], this.place_issue_combo),
        birth_location_id: pathOr(null, ["id"], this.birthLocation),
      };
      this.$emit("additem", payload);
    },
    fetchData() {
      if (this.item) {
        this.internal_code = pathOr(null, ["internal_code"], this.item);
        this.birth_certificate = pathOr(null, ["identify"], this.item);
        this.national_code = pathOr(null, ["national_code"], this.item);
        this.name = pathOr(null, ["name"], this.item);
        this.family = pathOr(null, ["family"], this.item);
        this.alias = pathOr(null, ["nickname"], this.item);
        this.previous_lastname = pathOr(null, ["previous_family"], this.item);
        this.father_name = pathOr(null, ["father_name"], this.item);
        this.birth_date = pathOr(null, ["birth_date", "gregorian"], this.item);
        this.adminIdentityChange = !!pathOr(
          false,
          ["admin_identity_change"],
          this.item
        );
        this.Place_issuance_identity_card = pathOr(
          null,
          ["place_issue"],
          this.item
        );
        const pic = pathOr([], ["attachments"], this.item).find(
          (x) => x.type == "thumb"
        );
        this.imageDisplay = pathOr("", ["address"], pic);
        this.allegiance = pathOr(null, ["allegiance_caption"], this.item);
        this.religion_selected = renderEumOptionsSelected(
          "religion",
          +pathOr(null, ["religion", "id"], this.item)
        );
        this.marriage_selected = renderEumOptionsSelected(
          "marriage",
          +pathOr(null, ["marriage", "id"], this.item)
        );
        this.gender_selected = renderEumOptionsSelected(
          "gender",
          +pathOr(null, ["gender", "id"], this.item)
        );
        this.military_service_status_selected = renderEumOptionsSelected(
          "military_type",
          +pathOr(null, ["military", "id"], this.item)
        );
        this.place_issue_combo = {
          id: pathOr("", ["place_issue_object", "id"], this.item),
          caption: `${pathOr(
            "",
            ["place_issue_object", "address_kind_caption"],
            this.item
          )} ${pathOr("", ["place_issue_object", "caption"], this.item)}`,
        };
        this.birthLocation = {
          id: pathOr(null, ["birth_location", "id"], this.item),
          caption: pathOr("", ["birth_location", "city_name"], this.item),
        };
      }
    },
    async personIdentityChange() {
      try {
        this.personIdentityLoading = true;
        const url = generateApiUrl(
          ["profile", "person_identity_change_code"],
          [this.code]
        );
        const response = await this.$httpService.get(url);
        this.personIdentityModal = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.personIdentityLoading = false;
      }
    },
    closePersonIdentityModal(refresh = false) {
      this.personIdentityModal = false;
      if (refresh) {
        this.$emit("getProfile");
      }
    },
    async getPlaceIssueCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.place_issue_combo_options = [];
      }

      try {
        this.place_issue_combo_Loading = true;
        let url = generateApiUrl(["resources", "location"]);
        url = `${url}?address_kind_id[]=1&address_kind_id[]=2&city=${query}`;
        const response = await this.$httpService.get(url);
        this.place_issue_combo_options = pathOr([], ["data", "data"], response);
        return data.map((item) => {
          return {
            id: item.id,
            caption: `${item.address_kind_caption} ${item.caption}`,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.place_issue_combo_Loading = false;
      }
    },
    async getBirthLocationCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.birthLocationOptions = [];
      }

      try {
        this.birthLocationLoading = true;
        let url = generateApiUrl(["resources", "location"]);
        url = `${url}?address_kind_id[]=1&city=${query}`;
        const response = await this.$httpService.get(url);
        this.birthLocationOptions = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.birthLocationLoading = false;
      }
    },
  },
};
</script>
